export default function emailTemplateBuilder(
	sessionTopic: string = "Data Structures and Algorithms",
	sessionTiming: string | null = null,
	sessionUrl: string | null = null
) {
	return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html dir="ltr" xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta content="width=device-width, initial-scale=1" name="viewport" />
    <meta name="x-apple-disable-message-reformatting" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta content="telephone=no" name="format-detection" />
    <title>New Message</title>
    <!--[if (mso 16)
      ]><style type="text/css">
        a {
          text-decoration: none;
        }
      </style><!
    [endif]-->
    <!--[if gte mso 9
      ]><style>
        sup {
          font-size: 100% !important;
        }
      </style><!
    [endif]-->
    <!--[if gte mso 9
      ]><xml>
        <o:OfficeDocumentSettings> <o:AllowPNG></o:AllowPNG> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings>
      </xml>
    <![endif]-->
    <!--[if mso]><style type="text/css">      ul {   margin: 0 !important;   }   ol {   margin: 0 !important;   }   li {   margin-left: 47px !important;   }  </style>
    <![endif] -->
    <style type="text/css">
      .es-p-default {
        padding-top: 20px;
        padding-right: 20px;
        padding-bottom: 0px;
        padding-left: 20px;
      }
      .es-p-all-default {
        padding: 0px;
      }
      @media only screen and (max-width: 600px) {
        .img-3078 {
          width: 120px !important;
        }
        h2 {
          font-size: 24px !important;
          text-align: left;
        }
        .es-header-body h2 a,
        .es-content-body h2 a,
        .es-footer-body h2 a {
          font-size: 24px !important;
        }
        .es-text-4240 .es-text-mobile-size-16,
        .es-text-4240 .es-text-mobile-size-16 * {
          font-size: 16px !important;
          line-height: 150% !important;
        }
        .es-text-4240 .es-text-mobile-size-14,
        .es-text-4240 .es-text-mobile-size-14 * {
          font-size: 14px !important;
          line-height: 150% !important;
        }
        .shadow {
          box-shadow: 15px 0 15px -15px inset;
        }
      }
      @media screen and (max-width: 384px) {
        .mail-message-content {
          width: 414px !important;
        }
      }
    </style>
  </head>
  <body class="body">
    <div dir="ltr" class="es-wrapper-color" lang="en">
      <!--[if gte mso 9]> <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t"> <v:fill type="tile" color="#f6f6f6"></v:fill> </v:background><![endif]-->
      <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" role="none">
        <tr>
          <td valign="top">
            <table class="es-header" cellspacing="0" cellpadding="0" align="center" role="none">
              <tr>
                <td align="center">
                  <table class="es-header-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" role="none" style="width: 600px">
                    <tr>
                      <td align="left">
                        <table cellpadding="0" cellspacing="0" width="100%" role="none">
                          <tr>
                            <td align="left" style="width: 600px">
                              <table cellpadding="0" cellspacing="0" width="100%" role="presentation">
                                <tr>
                                  <td align="center" class="es-m-p0t es-m-p0b" style="font-size: 0" height="75">
                                    <a target="_blank" href="https://cantileverlabs.com"><img src="https://gynade.stripocdn.email/content/guids/CABINET_f686a19509f9dc10c577821e9d3bb2640766402c02958449fbf9f260541023fe/images/image_iIM.png" alt class="img-3078 adapt-img" height="43" /></a>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left">
                        <table cellpadding="0" cellspacing="0" width="100%" role="none">
                          <tr>
                            <td align="center" valign="top" style="width: 560px">
                              <table cellpadding="0" cellspacing="0" width="100%" role="presentation">
                                <tr>
                                  <td align="center" style="font-size: 0">
                                    <table border="0" width="100%" height="100%" cellpadding="0" cellspacing="0" role="presentation">
                                      <tr>
                                        <td style="border-bottom: 1px solid #cccccc; background: unset; height: 1px; width: 100%; margin: 0px"></td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left">
                        <table cellpadding="0" cellspacing="0" role="none">
                          <tr>
                            <td align="left" style="width: 600px">
                              <table cellpadding="0" cellspacing="0" width="100%" role="presentation">
                                <tr>
                                  <td align="center" style="font-size: 0px">
                                    <img src="https://cantilever-blog-images.s3.ap-south-1.amazonaws.com/Image.png" alt width="600" class="adapt-img" style="display: block" />
                                  </td>
                                </tr>
                                <tr>
                                  <td align="center" style="font-size: 0">
                                    <table border="0" width="100%" height="100%" cellpadding="0" cellspacing="0" role="presentation">
                                      <tr>
                                        <td style="border-bottom: 1px solid #cccccc; background: unset; height: 1px; width: 100%; margin: 0px"></td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" class="es-text-4240 es-m-p5r">
                                    <p style="margin-left: 40px"><br /></p>
                                    <p style="margin-left: 40px" align="right">
                                      <strong>&nbsp;<%= formatted_date %> &nbsp; &nbsp; &nbsp;</strong>
                                    </p>
                                    <p style="margin-left: 40px">
                                      <strong><span class="es-text-mobile-size-16" style="font-size: 16px; line-height: 24px">Dear <%= firstName %>,</span></strong>
                                    </p>
                                    <p style="margin-left: 40px"><strong>THANK YOU! </strong>We're thrilled to have you on board and assure an&nbsp;</p>
                                    <p style="margin-left: 40px">enriching learning journey together.</p>
                                    <hr style="width: 50%; margin-left: 40px" />
                                    <p style="margin-left: 40px"><strong>LEARNING TRACK :</strong>&nbsp;For your daily training sessions</p>
                                    <p style="margin-left: 40px">
                                      Daily Session Topic -
                                      <b>${sessionTopic}</b>
                                    </p>
                                    ${
										sessionTiming
											? `<p style="margin-left: 40px">
                                      Daily Session Timing -
                                      <b>${sessionTiming}</b>
                                    </p>`
											: ""
									}
                                    ${
										sessionUrl
											? `<p style="margin-left: 40px">
                                      Daily Session Link -
                                      <a href="${sessionUrl}">${sessionUrl}</a>
                                    </p>`
											: ""
									}
                                    <p style="margin-left: 40px"><br /></p>
                                    <p style="margin-left: 40px"><strong>PRACTICE TRACK :</strong>&nbsp;For your daily practice</p>
                                    <p style="margin-left: 40px">
                                      Dashboard login page:
                                      <a href="https://cantileverlabs.com/login">https://cantileverlabs.com/login</a>
                                    </p>
                                    <p style="margin-left: 40px">Dashboard username: <%= email %></p>
                                    <p style="margin-left: 40px">Dashboard password: <%= password %></p>
                                    <hr style="width: 50%; margin-left: 40px" />
                                    <p style="margin-left: 40px">If you have any questions, feel free to message us at:</p>
                                    <p style="margin-left: 40px">support@cantileverlabs.com.</p>
                                    <p style="margin-left: 40px"><br /></p>
                                    <p style="margin-left: 40px">Best wishes!</p>
                                    <p style="margin-left: 40px"><br /></p>
                                    <p style="margin-left: 40px; font-size: 16px; line-height: 24px" class="es-text-mobile-size-16">
                                      <strong>Avanish Mundhra&nbsp;</strong>
                                    </p>
                                    <p style="margin-left: 40px; font-size: 14px; line-height: 21px">
                                      Founder & CEO
                                      <strong>- Cantilever Lab</strong>
                                    </p>
                                    <hr style="width: 87%" />
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left">
                                    <p align="center">
                                      <a href="https://cantileverlabs.com">www.cantileverlabs.com</a>
                                      &nbsp;| &nbsp;support@cantileverlabs.com
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="center" style="font-size: 0">
                                    <table cellpadding="0" cellspacing="14" class="es-table-not-adapt es-social" role="presentation">
                                      <tr>
                                        <td align="center" valign="top">
                                          <a target="_blank" href="https://www.instagram.com/cantilever_labs?igsh=NnN3bTZtanViZnht"><img title="Instagram" src="https://gynade.stripocdn.email/content/assets/img/social-icons/circle-colored/instagram-circle-colored.png" alt="Ig" width="24" height="24" /></a>
                                        </td>
                                        <td align="center" valign="top">
                                          <img title="Linkedin" src="https://gynade.stripocdn.email/content/assets/img/social-icons/circle-colored/linkedin-circle-colored.png" alt="In" width="24" height="24" />
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="center" style="font-size: 0">
                                    <table border="0" width="100%" height="100%" cellpadding="0" cellspacing="0" class="es-spacer" role="presentation">
                                      <tr>
                                        <td style="border-bottom: 1px solid #666666; background: none; height: 1px; width: 100%; margin: 0px"></td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table class="es-content" cellspacing="0" cellpadding="0" align="center" role="none">
              <tr>
                <td align="center">
                  <table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" role="none" style="width: 600px">
                    <tr>
                      <td align="left">
                        <table width="100%" cellspacing="0" cellpadding="0" role="none">
                          <tr>
                            <td valign="top" align="center" style="width: 560px">
                              <table width="100%" cellspacing="0" cellpadding="0" role="none">
                                <tr>
                                  <td align="center" style="display: none"></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table class="es-footer" cellspacing="0" cellpadding="0" align="center" role="none">
              <tr>
                <td align="center">
                  <table class="es-footer-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" role="none" style="width: 600px">
                    <tr>
                      <td align="left">
                        <table cellpadding="0" cellspacing="0" width="100%" role="none">
                          <tr>
                            <td align="center" valign="top" style="width: 560px">
                              <table cellpadding="0" cellspacing="0" width="100%" role="none">
                                <tr>
                                  <td align="center" style="display: none"></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left">
                        <table cellpadding="0" cellspacing="0" width="100%" role="none">
                          <tr>
                            <td align="center" valign="top" style="width: 560px">
                              <table cellpadding="0" cellspacing="0" width="100%" role="presentation">
                                <tr>
                                  <td align="center" style="font-size: 0">
                                    <table border="0" width="100%" height="100%" cellpadding="0" cellspacing="0" role="presentation">
                                      <tr>
                                        <td style="background: unset; height: 1px; width: 100%; margin: 0px"></td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </body>
</html>`;
}
